<ej-chart
  #LastChart
  id="line"
  style="height: 320px; width: 420px; display: block;"
  [isResponsive]="true"
  [legend.visible]="true"
  [primaryYAxis.title.text]="yAchsenBeschriftung"
  [primaryXAxis.title.text]="xAchsenBeschriftung"
  primaryXAxis.labelPlacement="onTicks"
  primaryYAxis.labelFormat="{value}"
  [commonSeriesOptions]="commonSeriesOptions"
  [enableCanvasRendering]="true"
  (legendItemClick)="getVisibilityOfSeries($event)"
>
  <e-seriescollection>
    <e-series
      name="Front"
      i18n-name="
        Label Front capacity chart|Label for 'Front' in capacity
        chart@@LabelFrontInCapacityChart"
      fill="#005AA0"
      xName="RadiusTAB"
      yName="LastTAB"
    ></e-series>
    <e-series
      name="Back"
      i18n-name="
        Label Back capacity chart|Label for 'Back' in capacity
        chart@@LabelBackInCapacityChart"
      fill="#44AEFF"
      xName="RadiusTAB"
      yName="LastTAB"
    ></e-series>
    <e-series
      name="Left"
      i18n-name="
        Label Left capacity chart|Label for 'Left' in capacity
        chart@@LabelLeftInCapacityChart"
      fill="#C51768"
      xName="RadiusTAB"
      yName="LastTAB"
    ></e-series>
    <e-series
      name="Right"
      i18n-name="
        Label Right capacity chart|Label for 'Right' in capacity
        chart@@LabelRightInCapacityChart"
      fill="#0AA046"
      xName="RadiusTAB"
      yName="LastTAB"
    ></e-series>
  </e-seriescollection>
</ej-chart>
